'use client';

import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypePromoDiscount } from '@/lib/api/productCatalog/types';

export interface UsePromoCreditsParams {
  userUuid: string;
  shouldFetch?: boolean;
}

export default function usePromoCredits({
  userUuid,
  shouldFetch = true,
}: UsePromoCreditsParams) {
  const uri = `${API_URLS.PRODUCT_CATALOG_PROXY}/promo_credits/${userUuid}`;

  const { data, isLoading, error } = useSWR<TypePromoDiscount[], Error>(
    shouldFetch ? uri : null,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data,
    isLoading,
    error,
  };
}
